import {
  GetNotesResponseModel,
  PropertyNotesModel
} from '../../../shared/models/properties/properties.models';
import {createReducer, on} from '@ngrx/store';
import {DefaultStoreState} from '../../models/app-state.model';
import { PropertyNotesActions } from '../../actions/property/property-notes.actions';

export const propertyNotesKey = 'propertyNotes';

export interface State extends DefaultStoreState {
  details: {
    sellerNotes: PropertyNotesModel[],
    propertyNotes: PropertyNotesModel[],
    propertyUserNotes: PropertyNotesModel[]
  };
}

export const initialState: State = {
  details: {
    sellerNotes: null,
    propertyNotes: null,
    propertyUserNotes: null
  },
  isLoading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(
    PropertyNotesActions.loadPropertyNotes,
    (state: State) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    PropertyNotesActions.loadPropertyNotesSuccess,
    (state: State, res: GetNotesResponseModel) => ({
      ...state,
      details: res.data,
      isLoading: false
    })
  ),
  on(
    PropertyNotesActions.loadPropertyNotesFailure,
    (state: State, error) => ({
      ...state,
      error
    })
  ),
);
